import { Box, Button, Drawer, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { DateTime } from 'luxon'
import React, { Component } from 'react'
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from '../../../Components/Common Components/CommonComponents'
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'
import { AmountsCard } from '../../../Components/CommonCards/CommonCards'
import { AmountFormat, formatDate } from '../../../Components/CommonFunctions/CommonFunctions'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { ImagePaths } from '../../../Utility/ImagePaths'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { CurrencySymbol } from '../../../Utility/Constants'
import { localGetItem } from '../../../Utility/Services/CacheProviderService'

export default class InsuranceReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            insuranceList: [],
            totalPatient: 0,
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            FilterOpen: false,
            InsuranceName: '',
            PatientName: '',
        }
    }

    componentDidMount() {
        this.getLabInsuranceList()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    getLabInsuranceList = () => {
        try {
            const baseUrl = (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_LAB_INSURANCE_REPORT : Serviceurls.LAB_INSURANCE_REPORT;
            RestAPIService.getAll(baseUrl + `?insurance_company_name=${this.state.InsuranceName}&patient_name=${this.state.PatientName}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            insuranceList: response.data.data ? response.data.data : [],
                            totalPatient: response.data.total_patient_count ? response.data.total_patient_count : 0,
                        })
                    }
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getLabInsurancePrint = () => {
        try {
            const baseUrl = (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_LAB_INSURANCE_REPORT : Serviceurls.LAB_INSURANCE_REPORT;
            RestAPIService.getAllPrint(baseUrl + `?export_type=pdf&insurance_company_name=${this.state.InsuranceName}&patient_name=${this.state.PatientName}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disableBtn: false })
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({ disableBtn: false })
        }
    }
    getLabInsuranceExcel = () => {
        try {
            const baseUrl = (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_LAB_INSURANCE_REPORT : Serviceurls.LAB_INSURANCE_REPORT;
            RestAPIService.excelGet(baseUrl + `?export_type=excel&insurance_company_name=${this.state.InsuranceName}&patient_name=${this.state.PatientName}&from_date=${this.state.fromDate}&to_date=${this.state.toDate}`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"].split("filename=")[1]

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false })
                    }
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({ disableBtn: false })
        }
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>

        )
    }

    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{('Filter')}</Typography>
                    <Button emed_tid='lab_insurance_report_filter_close_btn' onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            emed_tid='lab_insurance_report_patient_name'
                            fullWidth
                            size='small'
                            label={("Patient Name")}
                            name="PatientName"
                            value={this.state.PatientName}
                            onChange={(e) => { this.onChangeHandler(e) }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            emed_tid='lab_insurance_report_insurance_name'
                            fullWidth
                            size='small'
                            label={("Insurance Name")}
                            name="InsuranceName"
                            value={this.state.InsuranceName}
                            onChange={(e) => { this.onChangeHandler(e) }}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button emed_tid='lab_insurance_report_clear_btn' variant='outlined' size="small"
                        onClick={() => {
                            this.setState({
                                InsuranceName: '',
                                PatientName: '',
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            }, () => this.getLabInsuranceList())
                        }}
                        id="eMed_Config_btn">{("Clear")}</Button>
                    <Button emed_tid='lab_insurance_report_search_btn' variant='contained' size="small"
                        onClick={() => {
                            this.getLabInsuranceList()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    render() {
        this.state.insuranceList.forEach((element, index) => element.sno = index + 1)

        const columns = [
            {
                field: "patient_name", headerName: "Patient Details", flex: 0.33,
                renderCell: ({ row }) => (<Box component={'div'}><CommonPatientDetails disablePhoto={true} data={row} /></Box>)
            },
            {
                field: "insurance_company_name", headerName: "Insurance Details", flex: 0.33,
                renderCell: (params) => (
                    <Box component={'div'}>{params?.row?.insurance_company_name ?
                            <Box>
                                <Typography fontWeight={600} fontSize={'0.8vw'}>{params?.row?.insurance_company_name ? params?.row?.insurance_company_name : '-'}</Typography>
                                <Box display={'flex'}>
                                    <Typography fontSize={'0.8vw'}>{params?.row?.policy_number ? params?.row?.policy_number : '-'}</Typography>
                                </Box>
                            </Box>
                        : "-"}
                    </Box>)
            },
            {
                field: 'net_amount', headerName: ('Bill Amount') + `(${CurrencySymbol})`, sortable: false, flex: 0.33, type: "number",
                renderCell: (params) => (<div>{AmountFormat(params.row.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</div>)
            },

        ]
        return (
            <Box component={'div'}>
                <Box component={'div'} height={'79dvh'}>
                    <Box component={'div'} height={'15dvh'} alignItems={'center'} p={'0.8rem 0rem'} display={'flex'} justifyContent={'space-between'}>
                        <Box component={'div'} display={'flex'}>
                            {AmountsCard(("Total Patients"), this.state.totalPatient, true)}
                        </Box>
                        <Box component={"div"} sx={{ display: 'flex', gap: '0.5vw' }}>
                            <Tooltip title="Filter" placement='top' arrow>
                                <Button emed_tid='lab_insurance_report_filter_btn' className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                    <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Print" placement='top' arrow>
                                <Button emed_tid='lab_insurance_report_print_btn' className='eMed_usrconf_btn' onClick={() => this.setState({ disableBtn: true }, () => this.getLabInsurancePrint())}>
                                    <img src={ImagePaths.LabPrintIcon.default} alt="PrintIcon" className='eMed_action_img' />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Excel" placement='top' arrow>
                                <Button emed_tid='lab_insurance_report_export_btn' className='eMed_usrconf_btn' onClick={() => this.setState({ disableBtn: true }, () => this.getLabInsuranceExcel())}>
                                    <img src={ImagePaths.LabUploadButton.default} alt="LabUploadButton" className='eMed_action_img' />
                                </Button>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Box component={'div'} height={'64dvh'} p={'0rem 0.8rem'}>
                        <DataGrid
                            rows={this.state.insuranceList}
                            columns={columns}
                            getRowId={(row) => row['sno']}
                            page={this.state.page}
                            pageSize={this.state.pageSize}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            components={{
                                Toolbar: this.gridToolBar,
                                NoRowsOverlay: () => (
                                    <Box className='eMed_conf_nodata'>
                                        {("No Records Found")}
                                    </Box>
                                )
                            }}
                            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                            rowsPerPageOptions={[10, 20, 30]}
                            pagination
                            headerHeight={40}
                            disableSelectionOnClick
                            loading={this.state.isLoader}
                        />
                    </Box>
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}
